package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.dashboard.lib.api.ApiError
import kotlinx.datetime.LocalDate

object AuditExportCopy {
    const val BUTTON = "Export CSV"
    const val BUTTON_BUSY = "Exporting…"
    const val HINT = "Export CSV includes every entry that matches the filters, not only the loaded rows. " +
        "Limited to 2 exports per hour."
    const val DONE = "Audit log exported"
    private const val RATE_LIMITED_STATUS = 429

    fun fileName(date: LocalDate): String = "audit-log-$date.csv"

    fun failureMessage(error: ApiError): String =
        if (error is ApiError.Http && error.status == RATE_LIMITED_STATUS) {
            "You can export the audit log twice an hour. Try again in a little while."
        } else {
            "Export failed: ${error.displayMessage}"
        }
}
